export default __webpack_public_path__ + "static/cybersentinel-9ebb9fb0eed255e313b671138b3f4867.svg";